import axios from 'axios';
import { API_BASE_URL } from './apiConfig';

const readRows = async (path, token) => {
  const response = await axios.get(`${API_BASE_URL}/accounts/${path}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  const data = response.data;
  const rows = Array.isArray(data) ? data : data?.rows ?? data?.data;
  if (!Array.isArray(rows)) throw new Error(`Unexpected response from ${path}.`);
  return rows;
};

export const loadDispatchPricing = async token => {
  const [ledgerResult, marketResult] = await Promise.allSettled([
    readRows('product-pack-ledgers', token), readRows('market-changes', token),
  ]);
  const describe = error => error.response?.data?.message || error.message;
  const ledgerError = ledgerResult.status === 'rejected'
    ? `Unable to load margin configurations: ${describe(ledgerResult.reason)}` : '';
  const marketUnavailable = marketResult.status === 'rejected' && marketResult.reason.response?.status === 404;
  const marketError = marketResult.status === 'rejected' && !marketUnavailable
    ? `Unable to load market rates: ${describe(marketResult.reason)}` : '';
  return {
    ledgers: ledgerResult.status === 'fulfilled' ? ledgerResult.value : [],
    markets: marketResult.status === 'fulfilled' ? marketResult.value : [],
    error: [ledgerError, marketError].filter(Boolean).join(' '),
    warning: marketUnavailable ? 'Market-rate configuration is unavailable on this server. Prices use purchase cost and the matching saved margin configuration.' : '',
  };
};
